/**
 * Loads the Resources `chrome` UI labels into the `resources` namespace.
 *
 * Article copy (title/summary/body/navLabel) lives in the database and is
 * overlaid at runtime — see resourceContentOverride. Only chrome.json
 * (section names, library intros, Get Help, etc.) ships in the i18n files.
 *
 * Layout: locales/{locale}/resources/chrome.json
 */

import chrome from './locales/en-US/resources/chrome.json';

/** Bundled en-US resources namespace (chrome labels; article copy comes from the DB). */
export const resourcesEnUS: Record<string, unknown> = { chrome };

/** Lazy-load the chrome labels for a non-en-US locale (missing keys fall back to en-US). */
export async function loadResourcesLocale(locale: string): Promise<Record<string, unknown>> {
    if (locale === 'en-US') {
        return resourcesEnUS;
    }
    try {
        const mod = await import(`./locales/${locale}/resources/chrome.json`);
        return { chrome: mod.default ?? mod };
    } catch {
        return {};
    }
}
